import fetch from 'isomorphic-fetch';
import { serviceroot } from '../config';
import { buildBenchFromState } from './benhcRequestObjectBuilder';
let url = serviceroot + "api/BenchImageComponents/GetComponents"
var fetch_retry = require('fetch-retry')(fetch);
export const benchImageComponentService = (state) => {
    let requestObject = buildBenchFromState(state)
    let request = {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestObject)
    };
    return fetch_retry(url, request).
        then(response => handleResponse(response)).
        then(r => parseResponse(r));
}
let handleResponse = (response) => {
    return new Promise((resolve, reject) =>
    {
        if (response.ok) resolve(response.text());
        else reject(response.statusText);
    });
}


let parseResponse = (text) => {
    return JSON.parse(text);
}